import { OC } from "../../utils";
import { AdminAnalytics } from "./schema";

export const analyticsContract = OC.router({
  overview: {
    // Overview
    getTotalReservations: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.OverviewTotalReservations),
    getTotalDue: OC.meta({ permissions: ["analytics:get"] }).output(AdminAnalytics.OverviewTotalAmountDue),
    getNewClients: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.OverviewNewClients),
  },

  reservations: {
    // Reservations
    getOverTime: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsOverTime),
    getRevenueOverTime: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.RevenueOverTime),
    getStatusDistribution: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsStatusDistribution),
    getCancellationMetrics: OC.meta({
      permissions: ["analytics:get"],
    })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsCancellationMetrics),
    getAverageRevenue: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsAverageRevenue),
    getComposition: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsComposition),
    getAverageBookingLeadTime: OC.meta({
      permissions: ["analytics:get"],
    })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ReservationsAverageBookingLeadTime),
  },

  trips: {
    // Trips
    getTopByRevenue: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsTopByRevenue),
    getTopByReservations: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsTopByReservations),
    getStartingSoon: OC.meta({ permissions: ["analytics:get"] }).output(AdminAnalytics.TripsStartingSoon),
    getLowCapacity: OC.meta({ permissions: ["analytics:get"] }).output(AdminAnalytics.TripsLowCapacity),
    getAudienceDistribution: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsAudienceDistribution),
    getFoodDistribution: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsFoodDistribution),
    getTransportationDistribution: OC.meta({
      permissions: ["analytics:get"],
    })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsTransportationDistribution),
    getAccessibilityDistribution: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsAccessibilityDistribution),
    getGuidesDistribution: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.TripsGuidesDistribution),
  },

  // Clients
  clients: {
    getSegmentation: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ClientsSegmentation),
    getNewVsReturning: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ClientsNewVsReturning),
    getAcquisitionsOverTime: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ClientsAcquisitionsOverTime),
    getTopBySpend: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ClientsTopBySpend),
    getOutstandingDues: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.ClientsOutstandingDues),
  },

  // Payments
  payments: {
    getCompletionRate: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.PaymentsCompletionRate),
    getTotalPaid: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.PaymentsTotalPaid),
    getTotalDue: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.PaymentsTotalDue),
    getTotalRefunded: OC.meta({ permissions: ["analytics:get"] })
      .input(AdminAnalytics.DateRange)
      .output(AdminAnalytics.PaymentsTotalRefunded),
  },
});
